module.exports = __webpack_public_path__ + "static/img/zrzyb20d (1).c777ca0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/zrzyb20d (1).png
// module id = +rA8
// module chunks = 1